import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=49219bcb&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=js"
export * from "./IconPicker.vue?vue&type=script&lang=js"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=49219bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49219bcb",
  null
  
)

export default component.exports